import anime from 'animejs';
import $ from 'jquery';
// SIDEBAR 
const sidebarClean = () => {
  anime.remove('#sidebar');
}
const sidebarInit = () => {
  anime({
    targets: '#sidebar',
    translateX: -260,
    duration: 0
  });
}
const sidebarIn = () => {
  anime({
    targets: '#sidebar',
    translateX: -260,
    duration: 0
  })
  anime({
    targets: '#sidebar',
    translateX: -200,
    duration: 1000,
    offset: 0,
    delay: 300
  });
}
const sidebarOut = () => {
  return new Promise((resolve, reject) => {
    anime({
      targets: '#sidebar',
      translateX: -260,
      duration: 100,
      easing: 'easeInSine',
      complete: function(anim) {
        resolve();
      }
    });
  });
}
// HEADER
const headerClean = () => {
  anime.remove('#header');
  anime.remove('#curtain-l');
  anime.remove('#curtain-b');
  anime.remove('#curtain-r');
  anime.remove('#slider-data');
};
const headerInit = () => {
  anime({
    targets: '#header',
    translateY: 0,
    duration: 0
  });
  anime({
    targets: '#header-wrapper',
    translateY: 0,
    duration: 0
  });
}
const headerOut = () => {
  anime({
    targets: '#header',
    translateY: -80,
    duration: 2000,
    opacity: 0
  });
  anime({
    targets: '#header-wrapper',
    translateY: -80,
    duration: 1000,
    opacity: 0
  });
  anime({
    targets: '#curtain-l',
    translateX: -50,
    duration: 1000,
    opacity: 0
  });
  anime({
    targets: '#curtain-r',
    translateX: 50,
    duration: 1000,
    opacity: 0
  });
  anime({
    targets: '#curtain-b',
    translateY: 130,
    duration: 1000,
    opacity: 0
  });
  anime({
    targets: '#slider-data',
    translateY: 130,
    duration: 1000,
    opacity: 0
  });
};
const headerIn = () => {
  anime({
    targets: '#curtain-l',
    translateX: 0,
    duration: 50,
    opacity: 1
  });
  anime({
    targets: '#curtain-r',
    translateX: 0,
    duration: 50,
    opacity: 1
  });
  anime({
    targets: '#curtain-b',
    translateY: 0,
    duration: 50,
    opacity: 1
  });
  anime({
    targets: '#slider-data',
    translateY: 0,
    duration: 1000,
    easing: 'easeInOutBack',
    opacity: 1
  });
  anime({
    targets: '#header',
    translateY: 0,
    duration: 50,
    delay: 50,
    opacity: 1
  });
  anime({
    targets: '#header-wrapper',
    translateY: 0,
    // delay: 100,
    duration: 1000,
    easing: 'easeInOutBack',
    opacity: 1
  });
};

export default {
  headerClean,
  headerIn,
  headerOut,
  headerInit,

  sidebarIn,
  sidebarOut,
  sidebarClean,
  sidebarInit,
}


// WEBPACK FOOTER //
// ./src/utils/animations.js